import React from 'react';

export type BadgeVariant = 'count' | 'success' | 'warning' | 'error' | 'info';

export interface BadgeProps {
  variant?: BadgeVariant;
  children?: React.ReactNode;
  className?: string;
}

// Status variant base (shared by success / warning / error)
// Design system glass: pílula 11.5px/500, fundo de status em tint, sem borda.
const statusBase = 'inline-flex items-center gap-1.5 text-[11.5px] font-medium leading-tight px-2.5 py-1 rounded-pill whitespace-nowrap';

const variantClasses: Record<BadgeVariant, string> = {
  // Count badge: pill, gradient-colored, 22px min dimension per MOCK_TRUTH.json
  count: 'inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-pill bg-snapfy-primary text-white text-xs font-bold',

  // Status badges — semantic colors per DESIGN_SYSTEM.md; /10 and /30 are Tailwind alpha modifiers
  success: `${statusBase} bg-snapfy-success/15 text-snapfy-success`,
  warning: `${statusBase} bg-snapfy-warning/15 text-snapfy-warning`,
  error:   `${statusBase} bg-snapfy-error/15 text-snapfy-error`,

  // Info / new: primary tint, no border
  info: `${statusBase} bg-snapfy-primary-20 text-snapfy-text-accent`,
};

export const Badge: React.FC<BadgeProps> = ({
  variant = 'count',
  children,
  className = '',
}) => {
  return (
    <span className={`${variantClasses[variant]} ${className}`.trim()}>
      {children}
    </span>
  );
};

export default Badge;
